import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { IdlePoseGrouping } from '@ng-cloud/badger-core/map/groupings/idle-pose-grouping';
import { StoreZoneGrouping } from '@ng-cloud/badger-core/map/groupings/store-zone-grouping';
import { MapComponent } from '@ng-cloud/badger-core/map/map.component';
import { Map } from '@ng-cloud/badger-core/models/map';
import { StoreService } from '@ng-cloud/badger-core/services/store.service';

@Component({
  selector: 'bt-store-map',
  templateUrl: './store-map.component.html',
  styleUrls: ['./store-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MapComponent]
})
export class StoreMapComponent implements OnInit {
  @Input() storeId: number;

  map = signal<Map>(undefined);

  mapComponent: MapComponent;

  canvasOptions: any = {
    defaultCursor: 'pointer',
    allowTouchScrolling: true
  };
  zoneGrouping: StoreZoneGrouping = new StoreZoneGrouping();
  idlePoseGrouping: IdlePoseGrouping = new IdlePoseGrouping();

  constructor(protected storeService: StoreService) {
  }

  ngOnInit() {
    this.storeService.getMap(this.storeId).subscribe((map) => this.map.set(map));
    this.storeService
      .getZones(this.storeId)
      .subscribe((zones) => this.zoneGrouping.setData(zones));
    this.storeService
      .getPoses(this.storeId, { pose_type: 'idle' })
      .subscribe((poses) => this.idlePoseGrouping.addPoses(poses));
  }

  onMapLoad(mapComponent: MapComponent) {
    this.mapComponent = mapComponent;
    this.mapComponent.addGrouping(this.zoneGrouping);
    this.mapComponent.addGrouping(this.idlePoseGrouping);
    this.mapComponent.render();
  }
}
